var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Close, NotificationsRounded } from '@mui/icons-material';
import { Avatar, IconButton, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { deleteAllQueue, deleteQueue } from 'app/actions/notification';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const Snackbar = () => {
    const dispatch = useDispatch();
    const { session } = useSelector((state) => state.session);
    const { items } = useSelector((state) => state.notification);
    const handleNotificationClose = (value) => {
        dispatch(deleteQueue(value));
    };
    const handleAllNotificationsClose = () => {
        dispatch(deleteAllQueue(items));
    };
    const handleOpenAction = (_a) => {
        var { action } = _a, value = __rest(_a, ["action"]);
        action === null || action === void 0 ? void 0 : action();
        dispatch(deleteQueue(value));
    };
    const getNotificationTitle = (item) => {
        if (item.title) {
            return item.title;
        }
        if (item.isTransportEvent) {
            switch (item.event_id) {
                case 1:
                    return 'Одновременный слив';
                case 12:
                    return 'Выезд с налива недозалитым';
                default:
                    return 'Транспортное событие';
            }
        }
        return 'Новое уведомление';
    };
    const getNotificationColor = (item) => {
        if (item.headerColor) {
            return item.headerColor;
        }
        if (item.isTransportEvent) {
            switch (item.event_id) {
                case 1:
                    return '#ffc107';
                case 12:
                    return '#ec7d02';
                default:
                    return item.color;
            }
        }
        return item.color;
    };
    const needsWhiteText = (item) => {
        if (item.isTransportEvent && item.event_id === 12) {
            return true;
        }
        return false;
    };
    const canShowItem = (item) => {
        if (item.isOilParkingAlert) {
            return !!session.show_oil_parking_notification;
        }
        if (item.isTransportEvent) {
            return !!session.show_notification;
        }
        return true;
    };
    useEffect(() => {
        items.forEach((item) => {
            if (!canShowItem(item)) {
                handleNotificationClose(item);
            }
        });
    }, [items, session.show_notification, session.show_oil_parking_notification]);
    return (React.createElement(Stack, { direction: 'column', sx: (theme) => ({
            position: 'absolute',
            right: theme.spacing(3),
            bottom: theme.spacing(3),
            zIndex: theme.zIndex.notistack,
            maxHeight: '446px',
            width: '315px',
        }) },
        items.length > 0 && session.can_close_all_notification ? (React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                right: theme.spacing(1.5),
                top: theme.spacing(1.5),
                margin: '0 0 10px 0',
                justifyContent: 'space-between',
                width: '300px',
                flexShrink: 0,
                backgroundColor: 'background.paper',
                padding: theme.spacing(1, 1.5, 1, 2),
                borderRadius: theme.shape.borderRadius,
                opacity: '1',
                boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
                transition: 'none',
                overflow: 'hidden',
                button: {
                    padding: '6px',
                },
                '.MuiTypography-root': {
                    whiteSpace: 'nowrap',
                    margin: '0 12px',
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '13px',
                    lineHeight: '24px',
                    color: theme.palette.common.black,
                },
                '.MuiAvatar-root': {
                    width: '30px',
                    height: '30px',
                },
            }) },
            React.createElement(Avatar, null,
                React.createElement(NotificationsRounded, { fontSize: 'small' })),
            React.createElement(Typography, null, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0435 \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F"),
            React.createElement(IconButton, { color: 'default', onClick: handleAllNotificationsClose },
                React.createElement(Close, { fontSize: 'small' })))) : null,
        React.createElement(Stack, { direction: 'column', className: 'MuiNotifyStack-root', sx: (theme) => ({
                maxHeight: '446px',
                width: '315px',
                overflowY: 'auto',
                scrollbarWidth: 'thin',
                scrollbarColor: `${theme.palette.grey[500]} ${alpha(theme.palette.grey[500], 0.1)}`,
                '&::-webkit-scrollbar': {
                    width: '6px',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: theme.palette.grey[500],
                    borderRadius: '3px',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: alpha(theme.palette.grey[500], 0.1),
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                },
                '&:hover::-webkit-scrollbar-thumb': {
                    opacity: 1,
                },
                '&:hover::-webkit-scrollbar-track': {
                    opacity: 1,
                },
                '.MuiNotifyStack-item': {
                    bgcolor: 'background.paper',
                    marginBottom: theme.spacing(1),
                    '&:last-of-type': {
                        marginBottom: theme.spacing(0),
                    },
                },
            }) }, items.map((item) => {
            if (!canShowItem(item)) {
                return null;
            }
            const bgColor = getNotificationColor(item);
            const whiteText = needsWhiteText(item);
            return (React.createElement(Stack, { key: item.id, direction: 'column', className: 'MuiNotifyStack-item', sx: (theme) => ({
                    width: '300px',
                    flexShrink: 0,
                    bgcolor: 'background.paper',
                    padding: theme.spacing(0),
                    borderRadius: theme.shape.borderRadius,
                    opacity: '1',
                    boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
                    transition: 'none',
                    overflow: 'hidden',
                }) },
                React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => (Object.assign({ bgcolor: bgColor ||
                            (item.color ? theme.palette[item.color].main : 'background.default'), minHeight: '48px', position: 'relative' }, (whiteText && {
                        color: '#ffffff',
                    }))) },
                    React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => {
                            var _a;
                            return ({
                                padding: theme.spacing(0, 2),
                                '.MuiTypography-root': Object.assign({ whiteSpace: 'nowrap', margin: '0 12px', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px', lineHeight: '24px' }, (whiteText && {
                                    color: '#ffffff',
                                })),
                                '.MuiAvatar-root': {
                                    width: '30px',
                                    height: '30px',
                                    bgcolor: item.color
                                        ? (_a = theme.palette[item.color]) === null || _a === void 0 ? void 0 : _a.dark
                                        : alpha(theme.palette.primary.main, 0.12),
                                    path: Object.assign({ fill: item.color ? theme.palette.background.default : theme.palette.primary.main }, (whiteText && {
                                        fill: theme.palette.background.default,
                                    })),
                                },
                            });
                        } },
                        React.createElement(Avatar, null,
                            React.createElement(NotificationsRounded, { fontSize: 'small' })),
                        React.createElement(Typography, { variant: 'body1' }, getNotificationTitle(item))),
                    React.createElement(Stack, { direction: 'row', alignItems: 'center', component: 'ul', sx: (theme) => ({
                            position: 'absolute',
                            right: theme.spacing(1.5),
                            top: theme.spacing(1.5),
                            margin: '0',
                            marginLeft: 'auto',
                            listStyle: 'none',
                            li: {
                                margin: '0',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                button: Object.assign({ width: '32px', height: '32px' }, (whiteText && {
                                    color: '#ffffff',
                                })),
                            },
                            'li:not(:last-of-type) path': {
                                fill: whiteText ? '#ffffff' : theme.palette.text.secondary,
                            },
                        }) },
                        React.createElement("li", null,
                            React.createElement(IconButton, { color: 'default', onClick: () => handleNotificationClose(item) },
                                React.createElement(Close, { fontSize: 'small' }))))),
                React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                        display: 'grid',
                        gap: 0,
                        padding: theme.spacing(2),
                        '.MuiTypography-root:nth-of-type(2)': {
                            textAlign: 'right',
                            cursor: 'pointer',
                            color: theme.palette.primary.main,
                        },
                    }) },
                    React.createElement(Typography, { variant: 'body1' }, item.text),
                    item.action && (React.createElement(Typography, { variant: 'body1', onClick: () => handleOpenAction(item) }, item.actionLabel || 'Посмотреть подробнее')))));
        }))));
};
export default Snackbar;
